<div class="otp-container">
  <div class="otp-wrapper">
    <div class="otp-card">
      <!-- Brand Section -->
      <div class="otp-brand">
        <div class="logo-icon">
          <img src="/images/logo.png" alt="Unpluggit" />
        </div>
        <div class="brand-text">
          <h1>I<span>MS</span></h1>
          <p>Inventory Management System</p>
        </div>
      </div>

      <!-- Icon & Title -->
      <div class="otp-header">
        <div class="otp-icon">
          <i class="bi bi-shield-lock"></i>
        </div>
        <h2>Enter Verification Code</h2>
        <p>We sent a 6-digit code to your email</p>
      </div>

      <!-- Email Info -->
      <div class="otp-email">
        <i class="bi bi-envelope"></i>
        <span class="email-address">{{ maskedEmail }}</span>
        <button type="button" class="btn-change-email" (click)="goBack()">
          Change
        </button>
      </div>

      @if (demoOtp) {
        <div class="otp-demo-hint">
          <i class="bi bi-info-circle"></i>
          <span>Verification code: <strong>{{ demoOtp }}</strong></span>
        </div>
      }

      <!-- OTP Input -->
      <div class="otp-input-container">
        <div class="otp-input-group">
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="otp-input"
            id="otp1"
            appDigitsOnly
            [appMaxDigits]="1"
            (input)="onOtpInput($event, 'otp2')"
            (keydown)="onOtpKeydown($event, 'otp1', 'otp0')"
          />
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="otp-input"
            id="otp2"
            appDigitsOnly
            [appMaxDigits]="1"
            (input)="onOtpInput($event, 'otp3')"
            (keydown)="onOtpKeydown($event, 'otp2', 'otp1')"
          />
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="otp-input"
            id="otp3"
            appDigitsOnly
            [appMaxDigits]="1"
            (input)="onOtpInput($event, 'otp4')"
            (keydown)="onOtpKeydown($event, 'otp3', 'otp2')"
          />
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="otp-input"
            id="otp4"
            appDigitsOnly
            [appMaxDigits]="1"
            (input)="onOtpInput($event, 'otp5')"
            (keydown)="onOtpKeydown($event, 'otp4', 'otp3')"
          />
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="otp-input"
            id="otp5"
            appDigitsOnly
            [appMaxDigits]="1"
            (input)="onOtpInput($event, 'otp6')"
            (keydown)="onOtpKeydown($event, 'otp5', 'otp4')"
          />
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            class="otp-input"
            id="otp6"
            appDigitsOnly
            [appMaxDigits]="1"
            (keydown)="onOtpKeydown($event, 'otp6', 'otp5')"
            (input)="onOtpInput($event, '')"
          />
        </div>
      </div>

      <!-- Error Message -->
      <div class="error-message" [class.show]="showError">
        <i class="bi bi-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Resend Timer -->
      <div class="otp-resend">
        <p>Didn't receive the code?</p>
        <button
          class="btn-resend"
          (click)="resendCode()"
          [disabled]="resendDisabled"
        >
          <i class="bi bi-arrow-clockwise"></i>
          Resend Code <span *ngIf="resendDisabled">({{ timer }}s)</span>
        </button>
      </div>

      <!-- Actions -->
      <div class="otp-actions">
        <button
          class="btn-verify"
          (click)="verifyCode()"
          [disabled]="isVerifying"
        >
          <i class="bi bi-check-lg"></i>
          {{ isVerifying ? "Verifying..." : "Verify Code" }}
        </button>
        <button class="btn-back" (click)="goBack()">
          <i class="bi bi-arrow-left"></i>
          Back to Login
        </button>
      </div>

      <!-- Footer -->
      <div class="otp-footer">
        <p>&copy; 2026 IMS. All rights reserved.</p>
      </div>
    </div>

    <!-- Right Side Banner -->
    <div class="otp-banner">
      <div class="banner-content">
        <div class="banner-icon">
          <i class="bi bi-shield-check"></i>
        </div>
        <h2>Secure Two-Factor<br />Authentication</h2>
        <p>Protect your account with an additional layer of security.</p>
        <div class="banner-features">
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Extra security layer</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Prevents unauthorized access</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Real-time verification</span>
          </div>
          <div class="feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>24/7 account protection</span>
          </div>
        </div>
      </div>
      <div class="banner-footer">
        <span>Secure &bull; Reliable &bull; Professional</span>
      </div>
    </div>
  </div>
</div>

<!-- Success Toast -->
<div class="toast-container" [class.show]="showToast">
  <div class="toast success">
    <div class="toast-icon">
      <i class="bi bi-check-circle-fill"></i>
    </div>
    <div class="toast-content">
      <div class="toast-title">Success!</div>
      <div class="toast-message">{{ toastMessage }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
